import React from 'react';
import { useTranslation } from 'react-i18next';
import { DialogContent } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { typeDate } from 'components/mui/Formatters';
import { ModalActionProps } from 'models/AutoModals';
import { CarYard } from 'models/StockModel';


type ActivityDialogProps = {
    activity: CarYard[],
} & ModalActionProps

const YardActivityDialog = ({activity}: ActivityDialogProps) => {
    const {t} = useTranslation('cars');

    const columns: GridColDef<CarYard>[] = [
        {
            field: 'dateIn',
            headerName: t('yard_in'),
            flex: 1,
            ...typeDate,
        },
        {
            field: 'dateInConfirmedBy',
            headerName: t('confirmed_by'),
            valueFormatter: params => params.value?.name,
            flex: 1,
        },
        {
            field: 'name',
            headerName: t('name'),
            renderCell: params => `${params.row.port} ${params.row.name}`,
            flex: 1,
        },
        {
            field: 'dateOut',
            headerName: t('yard_out'),
            flex: 1,
            ...typeDate,
        },
        {
            field: 'dateOutConfirmedBy',
            headerName: t('confirmed_by'),
            valueFormatter: params => params.value?.name,
            flex: 1,
        },
        {
            field: 'location',
            headerName: t('location'),
            flex: 1,
        },
        {
            field: 'key',
            headerName: t('key_number'),
            flex: 1,
        },
    ];

    return (
        <DialogContent sx={{height: '60vh'}}>
            <DataGrid
                rows={activity}
                columns={columns}
                disableRowSelectionOnClick
                disableColumnFilter
                disableColumnMenu
                pageSizeOptions={[100]}
                getRowId={row => row.pivotId}
            />
        </DialogContent>
    );
};

export default YardActivityDialog;
